import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import PackageForm from "./PackageForm";
import { connect, useSelector } from "react-redux";
import { ApiError } from "components";
import { CreatePackageError, CreatePackageInput } from "../../../store/actionType";
import { createPackage, resetPackage } from "../../../store/action";
type OwnProps = {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
};
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & OwnProps & StateProps;
const HandleCreatePackage: React.FC<Props> = ({
  closeModal,
  onCreatePackage,
  onResetPackage
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState<CreatePackageInput>({
    name: "",
    description: "",
    package_type: "",
    package_order:0,
    information: "",
  });
  const [error, setError] = useState<CreatePackageError>({});
  const [apiError, setApiError] = useState(null);
  const packageState = useSelector(
    (state: any) => state.packages.createPackageState
  );
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();

    if (formData.name.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,

        name: "Package Name is required",
      }));
    }

    if (formData.description.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,
        description: "Package Description is required",
      }));
    }

    if (formData.package_type.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,

        package_type: "Package Type is required",
      }));
    }
    if (formData.package_order === 0) {
      setError((prevErrors) => ({
        ...prevErrors,

        package_order: "Package order is required",
      }));
    }
    if( formData.information.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,
        information: "Package Information is required",
      }));
    }
    if (
      formData.name.trim() !== "" &&
      formData.description.trim() !== "" &&
      formData.package_type.trim() !== "" 
    ) {
      setSubmitted(true)
      setLoading(true);
      try {
        await onCreatePackage(formData);
      } catch (err) {
        console.error("Failed to create package:", err);
      } finally {
        setLoading(false);
      }
    }
  };
    useEffect(() => {
      onResetPackage()
        if (!packageState.isLoading && submitted) {
          if (packageState.error) {
            setApiError(packageState.error); // show error
          } else {
            setApiError(null);
            closeModal(false);
          }
        }
      }, [packageState.isLoading, packageState.error, submitted]);
  return (
    <>
      <PackageForm
        handleSave={handleSave}
        formData={formData}
        handleChange={handleChange}
        error={error}
        loading={loading}
        header={"Create Package"}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    createPackages: state.packages.fetchPackagesState,
  };
};
const mapDispatchToProps = (dispatch: any) => ({
  onCreatePackage: (input: CreatePackageInput) =>
    dispatch(createPackage(input)),
  onResetPackage: () => dispatch(resetPackage()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HandleCreatePackage);
